import {createApp} from 'vue'
import Store from 'store'
import OrderOverview from './OrderOverview'



const el = '.nlx-component--order-overview'
const DOM = document.querySelector(el)

if(DOM){

    const customerServiceOrderTypes = DOM.getAttribute('data-customer-service-order-types')
    const proceedType = DOM.dataset.type

    const defaultFieldList = ['subTotal','orderTotal']
    const fieldList = DOM.dataset.fieldlist ? JSON.parse(DOM.dataset.fieldlist) : defaultFieldList
    
    if (customerServiceOrderTypes) {
        Store.commit('ecom/set_customer_service_order_types', JSON.parse(customerServiceOrderTypes))
    }

    const component = createApp(OrderOverview,{proceedType,fieldList}).use(Store)
    component.mount(el)
}

